/* NewsEntryList Messages
 *
 * This contains all the text for NewsEntryList component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.NewsEntryList.header',
    defaultMessage: 'News entries',
  },
  noNewsEntriesYet: {
    id: 'app.components.NewsEntryList.noNewsEntriesYet',
    defaultMessage: 'There are no news entries, yet.',
  },
  tableHeaderNews: {
    id: 'app.components.NewsEntryList.tableHeaderNews',
    defaultMessage: 'News',
  },
  tableHeaderVisibility: {
    id: 'app.components.NewsEntryList.tableHeaderVisibility',
    defaultMessage: 'Visible',
  },
  tableHeaderReadBy: {
    id: 'app.components.NewsEntryList.tableHeaderReadBy',
    defaultMessage: 'Read by',
  },
  visibleFrom: {
    id: 'app.components.NewsEntryList.visibleFrom',
    defaultMessage: 'from {from}',
  },
  visibleUntil: {
    id: 'app.components.NewsEntryList.visibleUntil',
    defaultMessage: 'until {until}',
  },
});
